import {
	MdOutlineBlock,
	MdOutlineComment,
	MdOutlineMarkChatRead,
	MdOutlineMarkChatUnread,
} from "react-icons/md";
import { PiShareFatBold } from "react-icons/pi";
import type { ToolbarOptionConfig } from "../../../../../../components/toolbar-dropdown/toolbar-dropdown.types";

export const DEFAULT_COMMENT_ACTION_OPTIONS: ToolbarOptionConfig[] = [
	{ id: "reply", label: "Reply", icon: MdOutlineComment },
	{ id: "share", label: "Post to feed", icon: PiShareFatBold },
	{ id: "read", label: "Mark as read", icon: MdOutlineMarkChatRead },
	{ id: "block", label: "Block user", icon: MdOutlineBlock },
];

export const SHARED_ACTION_OPTIONS: ToolbarOptionConfig[] = [
	{ id: "reply", label: "Reply", icon: MdOutlineComment },
];

export const ARCHIVED_COMMENT_ACTION_OPTIONS: ToolbarOptionConfig[] = [
	{ id: "unread", label: "Mark as unread", icon: MdOutlineMarkChatUnread },
	{ id: "block", label: "Block user", icon: MdOutlineBlock },
];
